import Vue from "vue";
import Vuex from "vuex";
import VorgangService from "./services/VorgangService";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    vorgaenge: [],
    adressen: [],
    materialien: [],
    techniker: [],
    arbeitsarten: []
  },

  mutations: {
    SET_VORGAENGE(state, vorgaenge) {
      state.vorgaenge = vorgaenge;
    },
    ADD_VORGANG(state, vorgang) {
      state.vorgaenge.unshift(vorgang);
    },
    UPDATE_VORGANG(state, vorgang) {
      let _vorgang = state.vorgaenge.find(v => v.id == vorgang.id);
      vorgang.techniker = state.techniker.find(
        t => t.id == vorgang.techniker_id
      );
      vorgang.arzt = state.adressen.find(t => t.id == vorgang.arzt_id);
      vorgang.material = state.materialien.find(
        t => t.id == vorgang.material_id
      );
      Object.assign(_vorgang, vorgang);
    },
    SET_ADRESSEN(state, adressen) {
      state.adressen = adressen;
    },
    SET_MATERIALIEN(state, materialien) {
      state.materialien = materialien;
    },
    ADD_MATERIAL(state, material) {
      state.materialien.push(material);
    },
    ADD_ADRESSE(state, adresse) {
      state.adressen.push(adresse);
    },
    SET_TECHNIKER(state, techniker) {
      state.techniker = techniker;
    },
    SET_ARBEITSARTEN(state, arbeitsarten) {
      state.arbeitsarten = arbeitsarten;
    }
  },
  actions: {
    loadVorgaenge({ commit }) {
      VorgangService.getVorgaenge().then(resp => {
        commit("SET_VORGAENGE", resp.data);
      });
    },

    addVorgang({ commit }, data) {

      Object.assign(data, {
        adresse_id: data.patient.id || 1,
        arzt_id: data.arzt.id,
        techniker_id: data.techniker.id,
        material_id: data.material.id,
        art: data.arbeitsart
      });

      // data.adresse_id = data.patient.id;
      // data.arzt_id = data.arzt.id;
      // data.techniker_id = data.techniker.id;
      // data.material_id = data.material.id;
      VorgangService.createVorgang(data).then(resp => {
        commit("ADD_VORGANG", resp.data);
      });
    },

    updateVorgang({ commit }, data) {
      VorgangService.updateVorgang(data).then(resp => {
        commit("UPDATE_VORGANG", resp.data);
      });
    },

    loadAdressen({ commit }) {
      VorgangService.getAdressen().then(resp => {
        commit("SET_ADRESSEN", resp.data);
      });
    },

    loadMaterialien({ commit }) {
      VorgangService.getMaterialien().then(resp => {
        commit("SET_MATERIALIEN", resp.data);
      });
    },

    addMaterial({ commit }, data) {
      return VorgangService.createMaterial(data).then(resp => {
        commit("ADD_MATERIAL", resp.data);
      });
    },

    addAdresse({ commit }, data) {
      return VorgangService.createAdresse(data).then(resp => {
        commit("ADD_ADRESSE", resp.data);
      });
    },

    loadTechniker({ commit }) {
      VorgangService.getTechniker().then(resp => {
        commit("SET_TECHNIKER", resp.data);
      });
    },

    loadArbeitsarten({ commit }) {
      VorgangService.getArbeitsarten().then(resp => {
        commit("SET_ARBEITSARTEN", resp.data);
      });
    }
  },
  getters: {
    patienten: state => {
      return state.adressen.filter(a => a.typ == "Patient");
    },
    aerzte: state => {
      return state.adressen.filter(a => a.typ == "Zahnarzt");
    }
  }
});
